var map = {
	"./absence-plans.svg": "63fb",
	"./add-attendance.svg": "6b56",
	"./add-departure.svg": "8836",
	"./addUser.svg": "bd85",
	"./address.svg": "597a",
	"./alert.svg": "49bb",
	"./allowances-daily-plans.svg": "7e59",
	"./allowances-plans.svg": "a71c",
	"./allowances.svg": "bbc4",
	"./approve-cancel-reservation.svg": "7a4d",
	"./approve-reservation.svg": "2bcd",
	"./attend-reservation.svg": "4e21",
	"./attendance.svg": "b007",
	"./attendanceHistory.svg": "da0b",
	"./balances-plans.svg": "e340",
	"./banks.svg": "75c8",
	"./bg-01.jpg": "33da",
	"./blood-types.svg": "1936",
	"./branch-privileges.svg": "a1a5",
	"./branch-roles.svg": "c6f2",
	"./branches.svg": "bbcf",
	"./buildings.svg": "95db",
	"./cancel-reservation.svg": "4260",
	"./cancel.svg": "541d",
	"./category.svg": "54d0",
	"./chambers.svg": "a1f9",
	"./changePassword.svg": "8d77",
	"./checkmark.svg": "f2fa",
	"./citizenship.svg": "dbb2",
	"./city.svg": "caa0",
	"./clients.svg": "90ee",
	"./code.svg": "2186",
	"./country.svg": "0901",
	"./date.svg": "9bcd",
	"./dateAndTime.svg": "47fe",
	"./days.svg": "8ef3",
	"./description.svg": "ec2e",
	"./diagnosis.svg": "8c05",
	"./disease.svg": "6282",
	"./district.svg": "7e17",
	"./doctors.svg": "a74f",
	"./drivingLicense.svg": "ccf6",
	"./earth.svg": "cb65",
	"./email.svg": "7711",
	"./employee-branches.svg": "df48",
	"./employee-salary-setting.svg": "3345",
	"./employees.svg": "91d3",
	"./enter-reservation.svg": "be5d",
	"./establishment-privileges.svg": "086d",
	"./establishment-roles.svg": "ca3b",
	"./establishment.svg": "57b6",
	"./expenses-types.svg": "a6bb",
	"./expenses.svg": "9ccb",
	"./eye-hide.svg": "4775",
	"./eye-show.svg": "c159",
	"./family.svg": "7bb6",
	"./filter.svg": "b05f",
	"./finance.svg": "10bd",
	"./finish-reservation.svg": "9471",
	"./floors.svg": "4557",
	"./gender.svg": "8bcb",
	"./general-specialities.svg": "0018",
	"./governate.svg": "f308",
	"./holiday.svg": "22b3",
	"./homepage.svg": "8cf7",
	"./hours.svg": "19bc",
	"./illustrator-forgot-password.svg": "7695",
	"./illustrator-login.svg": "2a0f",
	"./illustrator-mission.svg": "8edc",
	"./illustrator-noData.svg": "514c",
	"./illustrator-task.svg": "c515",
	"./illustrator-vision.svg": "e791",
	"./illustrator-work-time.svg": "1590",
	"./illustrator-work.svg": "8078",
	"./info.svg": "db39",
	"./insurance-companies.svg": "da5d",
	"./insurances-plans.svg": "84cb",
	"./insurances.svg": "5f53",
	"./jobs.svg": "e241",
	"./kilometer.svg": "d20a",
	"./kilometer2.svg": "4cf2",
	"./kilometer3.svg": "be8f",
	"./lang-ar.svg": "5b39",
	"./lang-en.svg": "b888",
	"./latitude.svg": "3432",
	"./location.svg": "3589",
	"./logo-admins-egypt.png": "f623",
	"./logo-jbs-denim.png": "944e",
	"./logo.png": "9d64",
	"./logout.svg": "4488",
	"./longitude.svg": "5fe3",
	"./main-columns.svg": "2c27",
	"./man.svg": "eb6f",
	"./maritalStatus.svg": "9a34",
	"./maxDiscountPercentage.svg": "b1ae",
	"./media.svg": "0500",
	"./medication-quantity.svg": "da1e",
	"./medicines-types.svg": "1467",
	"./medicines.svg": "6ec8",
	"./merge.svg": "f0dc",
	"./method-paids.svg": "0984",
	"./militaryStatus.svg": "b1d8",
	"./minutes.svg": "59e4",
	"./mode-dark.svg": "be60",
	"./mode-light.svg": "e7c3",
	"./money.svg": "095c",
	"./month-allowances-plans.svg": "1eb2",
	"./months-settings.svg": "0ce7",
	"./movement.svg": "8d1d",
	"./nationalNumber.svg": "1f8b",
	"./news-defult-img.svg": "f16c",
	"./news.svg": "8025",
	"./notes.svg": "bf2f",
	"./number.svg": "80e1",
	"./offers.svg": "1541",
	"./office-time.svg": "9d23",
	"./office.svg": "8de2",
	"./official-holidays-plans.svg": "8bef",
	"./overtime-plans.svg": "7fe3",
	"./passportNumber.svg": "f6c8",
	"./passwordlock.svg": "8600",
	"./pay.svg": "46d6",
	"./payment-method.svg": "8423",
	"./payroll.svg": "da48",
	"./pdf.svg": "5fe9",
	"./pencil.svg": "68e3",
	"./percentage.svg": "4be0",
	"./phone-landline.svg": "eef0",
	"./phone.svg": "cf63",
	"./plus.svg": "5860",
	"./points.svg": "dbc9",
	"./price-offer.svg": "ac89",
	"./privileges.svg": "d3d9",
	"./qualifications.svg": "0fb7",
	"./reason.svg": "465a",
	"./refund.svg": "9d70",
	"./relative-relation.svg": "4a7b",
	"./report.svg": "3c8a",
	"./reports.svg": "c387",
	"./requirement-types.svg": "d2f5",
	"./requirements.svg": "d4bc",
	"./revenues-types.svg": "c14c",
	"./revenues.svg": "1fad",
	"./salary-effects.svg": "881a",
	"./salary-settings.svg": "faec",
	"./scientific-degrees.svg": "1c4b",
	"./search.svg": "22ee",
	"./seconds.svg": "8fbb",
	"./sectors.svg": "7c7d",
	"./services-defalut.svg": "fdc6",
	"./services-payments.svg": "dee9",
	"./services-reservations.svg": "9789",
	"./services-types.svg": "64ca",
	"./services.svg": "0961",
	"./settings-additional.svg": "92b4",
	"./settings-establishment.svg": "7cdb",
	"./settings-general.svg": "437d",
	"./settings-other.svg": "cbba",
	"./settings-salary.svg": "ce6f",
	"./settings.svg": "09a5",
	"./sheets.svg": "ba9c",
	"./slices.svg": "b5cd",
	"./slider1.gif": "0d04",
	"./slider2.gif": "528e",
	"./slider3.gif": "c33c",
	"./slider4.gif": "eb72",
	"./special-spcialities.svg": "e769",
	"./store-roles.svg": "2764",
	"./stores.svg": "99c9",
	"./time.svg": "56de",
	"./trash.svg": "311a",
	"./treasuries-transactions.svg": "7740",
	"./treasuries.svg": "0909",
	"./treatments-reservation.svg": "7c732",
	"./type.svg": "bdf5",
	"./user.jpg": "3810",
	"./verification-code.svg": "b5ec",
	"./video-camera.svg": "463c",
	"./waiting-back.svg": "bfa1",
	"./work-plan-days.svg": "05be",
	"./work-plans.svg": "ddb4",
	"./work-schedule.svg": "f95f",
	"./work-shifts.svg": "98b4",
	"./year-settings.svg": "9d2a",
	"./year.svg": "5f60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";